/**
 * Prevent Angular change detection from running with certain callbacks
 */
(globalThis as any).__zone_symbol__BLACK_LISTED_EVENTS = [
    'requestAnimationFrame',
    'message',
    'scroll',
    'touchmove',
    'touchend',
    'mousemove',
    'mouseup',
    'pointermove',
    'pointercancel',
];
(globalThis as any).__Zone_disable_requestAnimationFrame = true;
